export default "__VITE_ASSET__BgBlwEQ1__"